import { execKemsuWebSystemPage } from "~/shared/api/kemsuweb"

/**
 * Выполняет выход из системы на KemsuWeb
 */
export function logoutKemsuWebSystem() {
	return execKemsuWebSystemPage("dekanat/restricted/logoff.htm")
}
